<template>
    <md-content class="card">
        <md-dialog-confirm :md-active.sync="confirmDeleteSurchargeDialog.active"
                           :md-title="$t('dialog.confirm-delete.title')"
                           :md-confirm-text="$t('dialog.confirm-delete.yes')"
                           :md-cancel-text="$t('dialog.confirm-delete.no')"
                           @md-cancel="cancelDeleteSurcharge"
                           @md-confirm="deleteSurchargeType(confirmDeleteSurchargeDialog.id)" />
        <div class="md-header-section">
            <md-content class="md-layout  md-alignment-space-around-space-between" :md-elevation="8">
                <div class="md-layout-item md-header-bg">
                    <h1 class="md-header-title">{{ $t('views.admin.configurations.surchargeType.title') }}</h1>
                </div>
                <div class="md-flex-right-align">
                    <div class="md-search-btn" v-if="!searchExpand" @click="searchExpand = !searchExpand">
                        <md-icon>search</md-icon>
                    </div>
                    <adsign-filter v-model="filterValue" v-if="searchExpand" :filter-data-model="filterDataModel"
                                   class=""
                                   @search="searchTemplate()" />
                    <conditional-router-link to="/configurations/surchargeType/create">
                        <md-button class="md-header-btn">
{{ $t('views.admin.configurations.surchargeType.add.label')
                            }}
                        </md-button>
                    </conditional-router-link>
                </div>
            </md-content>
        </div>

        <md-table v-model="surcharges.content" :md-sort.sync="currentSort" :md-sort-order.sync="currentSortOrder"
                  :md-sort-fn="customSort">
            <md-table-row slot="md-table-row" slot-scope="{ item, index }" ref="surchargeTable">
                <md-table-cell :md-label="$t('views.admin.configurations.surchargeType.table.id')">
{{ getNo(index)
                    }}
                </md-table-cell>
                <md-table-cell :md-label="$t('views.admin.configurations.surchargeType.table.name')"
                               md-sort-by="name">
{{ item.name }}
                </md-table-cell>
                <md-table-cell :md-label="$t('views.admin.configurations.surchargeType.table.expressions')">
                    <div v-for="(expression, expindex) in item.expressions" :key="expression.id">
                        {{ 1 + expindex + '. ' +expression.valueType.name + ' ' + $t(`views.admin.configurations.surchargeType.add.operators.${expression.operator}`) + ' ' +
                        expression.constValue }}
                    </div>
                </md-table-cell>
                <md-table-cell :md-label="$t('views.admin.configurations.surchargeType.table.active')"
                               md-sort-by="isDeleted">
{{ $t(`dialog.${!item.isDeleted}`) }}
                </md-table-cell>
                <md-table-cell :md-label="$t('views.admin.configurations.surchargeType.table.updatedBy')"
                               md-sort-by="updatedBy">
{{ item.updatedBy }}
                </md-table-cell>
                <md-table-cell :md-label="$t('views.admin.configurations.surchargeType.table.updatedAt')"
                               md-sort-by="updatedAt">
{{ item.updatedAt | moment('L') }}
                </md-table-cell>
                <md-table-cell :md-label="$t('views.admin.configurations.surchargeType.table.actions')">
                    <conditional-router-link :to="'/configurations/surchargeType/view/'+ item.id">
                        <md-button class="md-icon-button">
                            <md-tooltip md-direction="top">{{ $t('view') }}</md-tooltip>
                            <md-icon>info</md-icon>
                        </md-button>
                    </conditional-router-link>
                    <conditional-router-link :to="'/configurations/surchargeType/edit/'+ item.id">
                        <md-button class="md-icon-button">
                            <md-tooltip md-direction="top">{{ $t('edit') }}</md-tooltip>
                            <md-icon>description</md-icon>
                        </md-button>
                    </conditional-router-link>
                    <conditional-router-link :to="'/configurations/surchargeType/delete/'+ item.id">
                        <md-button class="md-icon-button"
                                   @click="showConfirmDeleteSurcharge( item )">
                            <md-icon>delete</md-icon>
                        </md-button>
                    </conditional-router-link>
                </md-table-cell>
            </md-table-row>
            <md-table-empty-state
                    v-if="!loading"
                    class="md-layout-item md-size-100"
                    :md-label="$t('dialog.noData')" />
            <Spiner :loading="loading" />
        </md-table>
        <div class="md-layout right">
            <paginator :page.sync="currentPage" :length="surcharges.totalElements || 0" :page-size.sync="pageSize"
                       @pageChange="loadSurcharges(currentPage, pageSize, sort, filterValue)" class="right" />
        </div>
        <md-progress-bar md-mode="indeterminate" v-if="sending" />
    </md-content>
</template>

<script>
  import {surchargesEndpoint} from '@/services/adsign-backend/endpoints';
  import ConditionalRouterLink from '@/components/ConditionalRouterLink';
  import {FilterType} from '@/mixins/filterType';
  import sortSupport from '@/mixins/sortSupport';
  import Paginator from '@/components/Paginator';
  import AdsignFilter from '@/components/AdsignFilter';
  import Spiner from '@/components/Spiner'

  export default {
    name: 'SurchargeTypeList',
    mixins: [sortSupport],
    components: {Paginator, ConditionalRouterLink, AdsignFilter, Spiner},
    props: {
      id: {
        type: [String, Number],
        default: undefined
      }
    },
    data: () => ({
      sending: false,
      searchExpand: false,
      confirmDeleteSurchargeDialog: {
        active: false,
        id: undefined
      },
      surcharges: {
        content: [],
        pageable: {
          pageSize: 0
        },
        totalElements: null
      },
      selectedSurcharge: null,
      currentSort: 'id',
      currentSortOrder: 'asc',
      filterValue: '',
      filterDataModel: [
        {id: 'name', type: FilterType.String},
        {id: 'isDeleted', type: FilterType.BooleanNot},
        {id: 'updatedBy', type: FilterType.String},
        {id: 'updatedAt', type: FilterType.Date},
      ],
      loading: false
    }),
    mounted() {
      this.searchTemplate();
    },
    methods: {
      customSort(value) {
        this.searchTemplate();
        return value;
      },
      loadSurcharges(page, pageSize, sort, filter) {
        this.loading = true
        return surchargesEndpoint.getAllSurchargeTypes(page - 1, pageSize, sort, filter).then(result => {
          this.surcharges = result.data;
        })
        .finally(() => this.loading = false)
      },
      deleteSurchargeType(id) {
        surchargesEndpoint.deleteSurchargeType(id).then(result => {
          this.loadSurcharges();
        })
            .finally(() => this.$router.push('/configurations/surchargeType'));
      },
      cancelDeleteSurcharge() {
        this.$refs.surchargeTable.MdTable.selectedItems = [];
        this.$router.push('/configurations/surchargeType');
      },
      showConfirmDeleteSurcharge(item) {
        this.$refs.surchargeTable.MdTable.selectedItems.push(item);
        this.confirmDeleteSurchargeDialog.active = true;
        this.confirmDeleteSurchargeDialog.id = item.id;
      },
      searchTemplate() {
        this.loadSurcharges(this.currentPage, this.pageSize, this.sort, this.filterValue);
      }
    }
  }
</script>

